import {TFunction} from "react-i18next";

export type TranslationProviderType = (key: string) => string;

export var translationProvider: TFunction<["translation", "event"], string> = (
  key: string
) => null;

export const initializeTranslationProvider = (
  translator: TFunction<["translation", "event"], string>
) => {
  translationProvider = translator;
};
